var React = require('react');

function SDCSkipLeft18N (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("rect",{"x":"4.25","y":"2.5","width":"1.5","height":"13","rx":"0.5","fill":"var(--iconFill, #464646)","key":0}),React.createElement("path",{"d":"M14.14389,15.28328,8.03213,9.3827a.5.5,0,0,1-.01242-.707l.00807-.00817,6.10988-6.04436a.5.5,0,0,1,.7071.00381l0,0,.35149.35541a.5.5,0,0,1-.00385.70705L9.81055,9.01367l5.375,5.19012a.5.5,0,0,1,.0127.70667l-.34708.36009a.5.5,0,0,1-.707.013Z","fill":"var(--iconFill, #464646)","key":1})]));
}

SDCSkipLeft18N.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = SDCSkipLeft18N;

SDCSkipLeft18N.default = SDCSkipLeft18N;
